import { createPopper } from "@popperjs/core";
import * as bootstrap from "bootstrap";
import $ from 'jquery';
import "./components/masonry";
import "./components/scrollspy";
import "./components/sliders";
import './components/nouria';
import './components/location-search';
import './components/location-search-ajax';
import './components/video';

//import './components/autocomplete';
//import './components/store-locator'; // No longer needed
const el = $( '.header-sticky' );
const elHeight = el.outerHeight();
let scrollTop = $( window ).scrollTop();
let lastScrollTop = 0;
$( window ).on('scroll', function( event ){
	let scrollTop = $( this ).scrollTop();

	if ( scrollTop > 0 ) {
		el.removeClass( 'header-initial-pos' ).addClass( 'header-scrolled-pos' );
	} else {
		el.removeClass( 'header-scrolled-pos' ).addClass( 'header-initial-pos' );
	}

	if ( scrollTop > elHeight ) {
		if ( scrollTop > lastScrollTop ) {
			$( 'body' ).removeClass( 'scroll-up' ).addClass( 'scroll-down' );
		} else {
			$( 'body' ).removeClass( 'scroll-down' ).addClass( 'scroll-up' );
		}
	}

	lastScrollTop = scrollTop
})


// Toggle radio button classes (Type of Order)

const radioButtons = document.querySelectorAll('input[name="orderType"]');

if ( radioButtons ) {

	radioButtons.forEach((checkbox) => {
		checkbox.addEventListener("change", function () {
			const parent = this.closest(".radio-button");
	
			const pickup = document.getElementById("pickup");
			const drivethru = document.getElementById("drivethru");
			const delivery = document.getElementById("delivery");
	
			if (this.checked) {
				if (this.id === "pickup" || this.id === "drivethru") {
					pickup.closest(".radio-button").classList.add("is-active");
					drivethru.closest(".radio-button").classList.add("is-active");
				} else if (this.id === "delivery") {
					document.querySelectorAll(".radio-button").forEach((el) => {
						el.classList.remove("is-active");
					});
				}
			} else {
				pickup.closest(".radio-button").classList.remove("is-active");
				drivethru.closest(".radio-button").classList.remove("is-active");
			}
		});
	});
}

